export default "__VITE_ASSET__B$HtEc1k__"